import { SearchTableState } from "./search-table-state";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";

export abstract class BaseService {

    constructor(
    ) { }

    protected updateFilterField(searchTableState: SearchTableState, filterProp: string, conditionProp: string): void {
        if (searchTableState[filterProp] && searchTableState[filterProp].length > 0) {
            searchTableState[filterProp] =
                (searchTableState[conditionProp] == 1 || searchTableState[conditionProp] == 2 ? '%' : '') +
                searchTableState[filterProp] +
                (searchTableState[conditionProp] == 0 || searchTableState[conditionProp] == 1 ? '%' : '');
        } else {
            searchTableState[filterProp] = null;
        }
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/base.service.ts